export default {"src":"/_next/static/media/appreciation.5cc8ecba.svg","height":196,"width":227,"blurWidth":0,"blurHeight":0};